import script from "./GroupsAuditLogLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsAuditLogLoader.vue?vue&type=script&setup=true&lang=js"

import "./GroupsAuditLogLoader.vue?vue&type=style&index=0&id=efe50c7c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efe50c7c"]])

export default __exports__